import React from 'react';
import PropTypes from 'prop-types';
import Heading from 'components/shared/heading';
import cn from 'classnames';
import FAQItem from './Item';
import styles from './styles.module.scss';

const FAQ = ({ title = null, items = [], theme = null }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <section className={cn(styles.faq, { [styles.themeLight]: theme === 'light' })}>
      <div className={styles.inner}>
        <div className="container">
          {title && (
            <Heading className={styles.title} tag="h2" size="xl">
              {title}
            </Heading>
          )}
          <div className={styles.items}>
            {items.map((item, index) => (
              <FAQItem key={item.id || index} item={item} index={index} theme={theme} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

FAQ.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    })
  ),
  theme: PropTypes.oneOf(['', 'light']),
};

export default FAQ;
